import { render } from "./ResetForm.vue?vue&type=template&id=53a2417c&scoped=true&ts=true"
import script from "./ResetForm.vue?vue&type=script&lang=ts"
export * from "./ResetForm.vue?vue&type=script&lang=ts"

import "./ResetForm.vue?vue&type=style&index=0&id=53a2417c&scoped=true&lang=css"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53a2417c"]])

export default __exports__